import { render } from "./CheckboxComponent.vue?vue&type=template&id=4412677b&scoped=true"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js"

import "./CheckboxComponent.vue?vue&type=style&index=0&id=4412677b&scoped=true&lang=scss"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4412677b"]])

export default __exports__